
var copypasteConfig = {};
var keywordDensityConfig = {};
var readonlyEditorConfig = {};
var ezdiaHtmlEmailTemplate = {};
var actionLinkArray = {};
var customer_config = {};
ezj.inputListDataArray = [];

function renderGrid(gridOptions) {
    var pager = "#footer";
    var colModel = gridOptions.colModel;
    var isFooterrow = gridOptions.isFooterrow || false;
    var arrSum = gridOptions.arrSum || [];
    var counter = 0;
    ezj.inputListDataArray = [];

    if (gridOptions.pager) {
        gridOptions.pager = pager + "_" + gridOptions.pager;
    }
    else {
        gridOptions.pager = pager;
    }

    var STATUS_CSS_MAPPING = $.ezdia.config.STATUS_CSS_MAPPING;
    for (var i = 0; i < colModel.length; i++) {
        var cm = colModel[i];
        if (cm.name === 'site_type') {
            cm.formatter = function (v) {
		var formattedHTML = '';
		if(siteTypes) {
		    $.each(siteTypes, function(key,value) {
			if(key === v) {
			    formattedHTML = '<div ';
			    formattedHTML += 'class="col-max-height"';
			    formattedHTML += '>' + value.label + '</div>';
			    return true;
			}
		    });
		} else {
		    formattedHTML = '<div ';
		    formattedHTML += 'class="col-max-height"';
		    formattedHTML += '>' + v + '</div>';
		}
		return formattedHTML;
	    };
	} else if(cm.name === 'project_type'){
            cm.formatter = function(v, options) {
                var str = $.ezdia.grid.projectTypeView(v);
                return str;
            };
            cm.unformat = function(v) {
                 return '<div class="col-max-height">' + v + '</div>';
            };
        } else if (cm.config && cm.config.accountName) {
	    cm.formatter = function(v) {
                return $.ezdia.grid.accountTypeView(v);
            };
            cm.unformat = function(v, options, cell) {
                var value = $('.col-max-height', cell).data('value')
                return '<div class="col-max-height">' + value + '</div>';
            };
	} else if (cm.edittype === 'date') {
            cm.formatter = function(v, options) {
                v = v || '';
                return '<div class="col-max-height" data-date="'+ v +'">' + $.ezdia.date.view(options.colModel, v) + '</div>';
            };
        } else if (cm.edittype == 'group') {
            cm.formatter = function(v, options) {
                return '<div class="col-max-height" data-value="'+ v +'">' + $.ezdia.typehead.view(v, options.colModel.config) + '</div>';
            };
            cm.unformat = function(v, options, cell) {
                return $('.col-max-height', cell).data('value');
            };
        } else if (cm.edittype == 'role') {
            cm.formatter = function(v, options) {
                var mval = v;
                if (options.colModel.config && options.colModel.config.url) {
                    mval = $.ezdia.typehead.view(v, options.colModel.config);
                }
                return '<div class="col-max-height" data-value="'+ v +'">' + mval + '</div>';
            };
            cm.unformat = function(v, options, cell) {
                return $('.col-max-height', cell).data('value');
            };
        } else if(cm.edittype === 'url'){
            cm.formatter = function(v) {
                var url = decodeURIComponent(v);
                var encode = '';
                if (url == v) {
                    encode = 'encode';
                    url = encodeURI($.trim(v));
                } else {
                    url = v;
                }

                return '<div class="col-max-height" data-encode="'+ encode +'" data-url="'+ url +'">' + buildUrlField('', v) + '</div>';
            };
        } else if(cm.edittype === 'filetype' || cm.edittype === 'file'){
            cm.formatter = function(v) {
                return '<div class="col-max-height" data-value="'+ v +'">' + v + '</div>';
            };
            cm.unformat = function(v, options, cell) {
                return '<div class="col-max-height">'+ v +'</div>';;
            };
        } else if(cm.edittype === 'inputlist'){
            cm.formatter = function(v) {
                var str = '<div class="col-max-height" data-index="'+counter+'">'+gridInputListDataFormatter(v, counter)+'</div>';
                counter++;
                return str;
            };
        } else if(cm.edittype === 'tag' || cm.edittype  === 'combo'){
            cm.formatter = function(v, options) {
                var str = '<div class="col-max-height" data-value="' + v +'">'+ $.ezdia.tagInput.view(options.colModel, v) +'</div>';
                return str;
            };
        } else if(cm.edittype === 'multichoice'){
            cm.formatter = function(v, options) {
                var str = '<div class="col-max-height" data-value="' + v +'">'+ $.ezdia.multichoice.view(v) +'</div>';
                return str;
            };
        } else if(cm.edittype === 'singlechoice'){
            cm.formatter = function(v, options) {
                var classes = '';
                if (STATUS_CSS_MAPPING[v]) {
                    classes = STATUS_CSS_MAPPING[v]
                }
                var str = '<div class="col-max-height ' + classes +'" data-value="' + v +'">'+ $.ezdia.singlechoice.view({
                    column: options.colModel,
                    value: v
                }) +'</div>';
                return str;
            };
            cm.unformat = function(v, o, cell) {
                v = $('.col-max-height', cell).data('value');
                if ( typeof v !== "undefined" && v !== null ) {
                    v = v.toString();
                }
                return v;
            };
        } else if(cm.edittype === 'inline'){
            cm.formatter = function(v, options) {
                var str = '<div class="col-max-height">'+ escapeHtml(v) +'</div>';
                return str;
            };
        } else {
            if ((cm.edittype === 'textarea' || cm.edittype === 'comment') && cm.editable) {
                cm.formatter = function(v) {
                    var v = escapeHtml(v);
                    var formattedHTML = '<div ';
                    formattedHTML += 'class="col-max-height"';
                    formattedHTML += '>' + v + '</div>';
                    return formattedHTML;
                };
            } else if(cm.edittype === 'json'){
                cm.formatter = function(v) {
                    var v = escapeHtml(v);
                    var v = '<div class="col-max-height">'+ v +'</div>';
                    return v;
                };
                cm.unformat = function(v) {
                    return v;
                };
            } else if(cm.edittype === 'inputtab'){
                cm.formatter = function(v) {
                    var v = escapeHtml(v);
                    var v = '<div class="col-max-height">'+ v +'</div>';
                    return v;
                };
                cm.unformat = function(v) {
                    return v;
                };
            } else if(cm.edittype === 'html'){
                cm.formatter = function(v) {
                    var v = escapeHtml(v);
                    var v = '<div class="col-max-height">'+ v +'</div>';
                    return v;
                };
                cm.unformat = function(v) {
                    return v;
                };
            } else {
                cm.formatter = function(v) {
                    v = $.ezdia.sanitizer.script(v);
                    v = $('<div>',{
                        html: v
                    }).html();
                    var formattedHTML = '<div ';
                    formattedHTML += 'class="col-max-height"';
                    formattedHTML += '>' + v + '</div>';
                    return formattedHTML;
                };
            }
        }
        if (cm.metadata) {
            $.each(cm.metadata.split(","), function(i, v) {
                if (v === 'sum') {
                    cm.align = 'right';
                    cm.unformat =  function(v) {
                        return v;
                    };
                    isFooterrow = true;
                    arrSum.push(cm.name);
                    return false;
                }
            });
        }
    }

    defaultOptions = {
        datatype: "local",
        viewrecords: true,
        autowidth: true,
        shrinkToFit: false,
        width: '100%',
        height: (/MSIE/.test(navigator.userAgent)) ? '' : 'auto',
        footerrow: isFooterrow,
        //loadtext: $.ezdia.loading.writingTips(),
        loadtext: $.ezdia.loading.default(),
        loadComplete: function() {
            var self = $(this);
            if (arrSum.length) {
                $.each(arrSum, function (i, colName){
                    var total=  self.jqGrid('getCol', colName, false, 'sum');
                    var obj = {};
                    obj[colName] = total;
                    self.jqGrid('footerData', 'set', obj);
                });
            }
            setGridCellTitle(gridOptions.gridid);

        },
        localReader: {
            page: function (obj) {
                if (obj.rows == null || obj.rows.length === 0) {
                    return "0";
                }
            }
        }
    };
    $.extend(defaultOptions, gridOptions);
    $(gridOptions.gridid).jqGrid(defaultOptions);
    if($(gridOptions.pager) !== undefined){
        $(gridOptions.gridid).jqGrid('navGrid', gridOptions.pager, {add: false, edit: false, del: false, search: false});
    }
    $(gridOptions.gridid).jqGrid('navButtonAdd', gridOptions.pager, {
        caption: "",
        buttonicon: "glyphicon-filter",
        title: "Choose Columns",
        id: 'chooseColumns_' + gridOptions.gridid.slice(1),
        onClickButton: function() {
            $(this).jqGrid('columnChooser');
        }
    });
    if (gridOptions.isExport) {
        $(gridOptions.gridid).jqGrid('navButtonAdd', gridOptions.pager, {
            caption: "",
            buttonicon: 'glyphicon-download-alt',
            title: "Export Data",
            id: 'columnExport_grid',
            onClickButton: genericExport
        });
    }
    if(gridOptions.remote && gridOptions.remote === true){
        $(gridOptions.gridid).jqGrid('setGridParam', {
            url: gridOptions.url,
            datatype:'json',
            mtype:'POST',
            jsonReader: {
                records: 'records',
                root: 'data',
                total: 'total',
                page: 'page'
            },
            postData: {
                formtype: $("#pageTemplateName").val(),
                accountName: $('#accountName').val()
            }
        }).trigger("reloadGrid", [{current: true}]);
    }
}

function renderHTMLEditor(editorOptions) {
    var id = "#" + editorOptions.name;
    var value = editorOptions.value || {};
    var url = (editorOptions.ctx ? editorOptions.ctx : '..');
    var options = {
        theme_advanced_toolbar_location: "top",
        theme_advanced_toolbar_align: "left",
        theme_advanced_statusbar_location: "bottom",
        theme_advanced_resizing: true,
        paste_strip_class_attributes: "all",
        paste_remove_spans: true,
        paste_text_sticky: true,
        element_format: "html",
        elements: "advimage",
        forced_root_block: false,
        verify_html: false,
        apply_source_formatting: false,
        allow_script_urls: true,
        width: "100%",
        height: (!readonlyEditorConfig[editorOptions.index]) ? "250px" : '0',
        accountname: editorOptions.accountName,
        role: editorOptions.role,
        gecko_spellcheck: true,
        spellchecker_language: "en-us",
        spellchecker_languages: "+English=en-us",
        spellchecker_rpc_url: url + "/jmyspell-spellchecker",
        copypaste_var: copypasteConfig[editorOptions.index],
        keyword_density: keywordDensityConfig[editorOptions.index],
        readonly: readonlyEditorConfig[editorOptions.index],
        //ezdia_template: ezdiaHtmlEmailTemplate[editorOptions.index],
        local_storage: editorOptions.localStorage || false,
        entity_encoding: "raw",
        extended_valid_elements: "link[*], a[href|target=_blank]",
        custom_elements: "link",
        relative_urls: false,
        remove_script_host: false,
        convertUrls: true,
        branding: false,
        file_picker_types: 'image media', 
        file_picker_callback: $.ezdia.html.upload,
        valid_children : ["+body[style]"]
    };
    if (ezdiaHtmlEmailTemplate[editorOptions.index]) {
        //options.ezdia_template = $.ezdia.templateDb.get(ezdiaHtmlEmailTemplate[editorOptions.index].name, ezdiaHtmlEmailTemplate[editorOptions.index].type);
        options.ezdia_template = $.ezdia.getEditorTemplate(ezdiaHtmlEmailTemplate[editorOptions.index].name, ezdiaHtmlEmailTemplate[editorOptions.index].type);
    }
    if (editorOptions.wordsum && editorOptions.wordsum.length) {
        var arr = [];
        $.each(editorOptions.wordsum, function(i, obj){
            var config = obj.fields;
            if (config) {
                if ($.inArray(editorOptions.name, config) !== -1) {
                    arr.push(obj);
                }
            }
        });

        if (arr.length) {
            options.wordsum = arr;
        }

    }

    if(editorOptions.convertUrls === false || value.convertUrls === false){
        options.relative_urls = true;
        options.remove_script_host = true;
        options.convertUrls = false;
    }
    
    if (value) {
        if (value.height) {
            options['height'] = value.height;
        }
        if (value.charcount) {
            options.charcount = value.charcount;
        }
        if (value.wordcount) {
            options.wordcount = value.wordcount;
        }
        if (value.badcontent) {
            options.badcontent = value.badcontent;
        }
        if (value.upload) {
            options.upload_file = true;
        }
        if (value.toggle) {
            options.toggle = true;
        }
        if (value.paste_as_text) {
            options.paste_as_text = true;
        }
        
        if (value.text_encoder) {
            options.text_encoder = true;
        }
        
        if (value.stc) {
            options.ice = {user: {name: editorOptions.trackChName, id: editorOptions.userId}};
            var htmlVal = $(id).html();
            if (htmlVal && htmlVal.indexOf("data-cid") !== -1 && htmlVal.indexOf("data-userid")) {
                options.ice.isTracking = 1;
            } else {
                options.ice.isTracking = 0;
            }
        }

    }
    extendOptions(options, value, editorOptions);
    var customer_config = editorOptions.customer_config;
    var role = editorOptions.role;
    var index = editorOptions.index;
    var config = {};
    
    if (customer_config) {
        var accountConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()].tinymce;
        var roleConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()][role]
                && customer_config[$('#accountName').val()][role].tinymce;
        var elementConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()][role]
                && customer_config[$('#accountName').val()][role][index] &&
                customer_config[$('#accountName').val()][role][index].tinymce;
        if (!elementConfig) {
            elementConfig = customer_config[$('#accountName').val()] && customer_config[$('#accountName').val()][index] &&
                    customer_config[$('#accountName').val()][index].tinymce;
        }
        config = $.extend({}, accountConfig, roleConfig, elementConfig);
        config =  !$.isEmptyObject(config) ? $.ezdia.getCustomerConfig(config) : {};

        $.extend(options, config);
    }

    if (getEditor(editorOptions.name)) {
        tinyMCE.editors= [];
    }

    $(id).tinymce(options);
    $.ezdia.config.iseditor = true;
}

var extendOptions = function(options, metadata, editorOptions){
    var obj = {};
    var url = (editorOptions.ctx ? editorOptions.ctx : '..');
    var buttons;
    metadata = metadata || {};
    if (tinymceVersion == 3) {
        obj = {
            script_url: url + '/style/js/tinymce/tiny_mce.js?' + ezjversion,
            theme: "advanced",
            plugins: "autolink,lists,pagebreak,spellchecker,style,layer,table,save,advhr,advimage,emotions,iespell,inlinepopups,insertdatetime,preview,media,searchreplace,print,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,template,advlist,ezdia,codemagic"
        };

        if ($.isEmptyObject(metadata)) {
            buttons = "formatselect,bold,italic,underline,bullist,link,unlink,ezdia,spellchecker,image,table,justifyleft,justifycenter,justifyright,justifyfull,codemagic,fullscreen,badcontent,templateselect,ice_togglechanges,ice_toggleshowchanges,iceacceptall,icerejectall,iceaccept,icereject,addComment,removeCommentAll,removeComment,copypaste";
        } else {
            var buttonsA = [];
            var found = false;
            if (metadata.dfs) {
                buttonsA.push("bold,italic,underline");
                found = true;
            }
            if (metadata.dbl) {
                buttonsA.push("bullist");
                found = true;
            }
            if (metadata.dwc) {
                buttonsA.push("wordcount");
                found = true;
            }
            if (metadata.dcc) {
                buttonsA.push("charcount");
                found = true;
            }
            if (metadata.dsc) {
                buttonsA.push("spellchecker");
                found = true;
            }
            if (metadata.dlp) {
                buttonsA.push("link");
                buttonsA.push("unlink");
                found = true;
            }
            if (metadata.img) {
                buttonsA.push("image");
                found = true;
            }
            if (metadata.sbc) {
                buttonsA.push("badcontent");
                found = true;
            }
            if (found) {
                buttons = buttonsA.join(",");
            } else {
                buttons = "formatselect,bold,italic,underline,bullist,link,unlink,ezdia,spellchecker,image,table,justifyleft,justifycenter,justifyright,justifyfull,codemagic,fullscreen,badcontent,templateselect,ice_togglechanges,ice_toggleshowchanges,iceacceptall,icerejectall,iceaccept,icereject,addComment,removeCommentAll,removeComment,copypaste";//,negativewordchecker";
            }

            if (metadata.htmlcopy) {
                options.setup = function(ed) {
                    ed.onInit.add(function() {
                        ed.pasteAsPlainText = true;
                        ed.onSaveContent.add(function() {
                            removeHighlightKeyword(ed.id);
                        });
                    });
                };
            }

            if (metadata.plainText) {
                options.setup = function(ed) {
                    ed.onInit.add(function(ed) {
                        ed.pasteAsPlainText = true;
                        ed.onSaveContent.add(function() {
                            removeHighlightKeyword(ed.id);
                            ed.setContent(convertHtmlToPlainText(ed.id));
                        });
                    });
                };
            }

            if (metadata.sct) {
                obj.plugins += ',comments';
            }

            if (metadata.stc) {
                obj.plugins += ',ice,icesearchreplace';
            }
        }
        options.theme_advanced_buttons1 = buttons;
    } else {
        obj = {
            theme: 'modern',
            plugins: [ "advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks codemirror fullscreen", "insertdatetime media table paste", "ezdia"]
        };
        if ($.isEmptyObject(metadata)) {
            obj.toolbar1 = 'insertfile undo redo | styleselect | bold italic underline | bullist numlist outdent indent | link unlink | table image media | alignleft aligncenter alignright alignjustify spellchecker | code  fullscreen | forecolor backcolor'
            obj.toolbar2 = 'badcontent ezdiaUpload | ice_togglechanges ice_toggleshowchanges iceacceptall icerejectall iceaccept icereject | addComment removeCommentAll removeComment | templateselect | copypaste';
        } else {
            var buttonsA = [];
            var found = false;
            if (metadata.dfs) {
                buttonsA.push("bold,italic,underline");
                found = true;
            }
            if (metadata.dbl) {
                buttonsA.push("bullist");
                found = true;
            }
            if (metadata.dwc) {
                buttonsA.push("wordcount");
                found = true;
            }
            if (metadata.dcc) {
                buttonsA.push("charcount");
                found = true;
            }
            if (metadata.dsc) {
                buttonsA.push("spellchecker");
                found = true;
            }
            if (metadata.dlp) {
                buttonsA.push("link");
                buttonsA.push("unlink");
                found = true;
            }
            if (metadata.img) {
                buttonsA.push("image");
                found = true;
            }
            if (metadata.sbc) {
                buttonsA.push("badcontent");
                found = true;
            }
            if (found) {
                buttons = buttonsA.join(" ");
                obj.menubar = false;
                obj.toolbar1 = buttons;
            } else {
                obj.toolbar1 = 'insertfile undo redo | styleselect | bold italic underline | bullist numlist outdent indent | link unlink | table image media | alignleft aligncenter alignright alignjustify spellchecker | code  fullscreen | forecolor backcolor';
                obj.toolbar2 = 'badcontent ezdiaUpload | ice_togglechanges ice_toggleshowchanges iceacceptall icerejectall iceaccept icereject | addComment removeCommentAll removeComment | templateselect | copypaste';
            }

            if (metadata.htmlcopy) {
                options.setup = function(ed) {
                    ed.on('Init', function() {
                        ed.pasteAsPlainText = true;
                        ed.on('SaveContent', function() {
                            removeHighlightKeyword(ed.id);
                        });
                    });
                };
            }

            if (metadata.plainText) {
                options.setup = function(ed) {
                    ed.on('Init', function() {
                        ed.pasteAsPlainText = true;
                        ed.on('SaveContent', function() {
                            removeHighlightKeyword(ed.id);
                            ed.setContent(convertHtmlToPlainText(ed.id));
                        });
                    });
                };
            }

            if (metadata.sct) {
                options.comments = true;
            }          
            if (metadata.stc) {
                obj.plugins.push('ice');
            }
            
            if (metadata.languagetool) {
                var lt;
                
                if (typeof metadata.languagetool !== "object") {
                    lt = {
                        enable: true
                    };
                } else {
                    lt = metadata.languagetool;
                }
                
                options.languagetool = lt;
            } else {
                obj.plugins.push('spellchecker');
            }         
        }

    }

    if (readonlyEditorConfig[editorOptions.index]) {
        obj.toolbar1 = 'false';
        obj.toolbar2 = 'false';
        obj.menubar = false;
        obj.statusbar = false;
        
        if (metadata.readonlyHeight) {
            options.readonlyHeight = metadata.readonlyHeight;
            options.height = metadata.readonlyHeight;
        } else {
            obj.plugins.push("autoresize");
            obj.autoresize_overflow_padding = 0;
            obj.autoresize_overflow_padding = 0;
            obj.autoresize_bottom_margin = 0;            
        }
    }

    $.extend(options, obj);
};

var getEditor = function(id){
    var ed = null;

    try {
        ed = tinymce.get(id);
        ed.getBody();
    }
    catch (err) {
        ed = null;
    }

    return ed;
};

function createHTMLElement(htmlEditorOptions) {
    $.each(htmlEditorOptions.htmlEditorArray, function(index, value) {
        renderHTMLEditor({
            customer_config: htmlEditorOptions.customer_config,
            accountname: htmlEditorOptions.accountName,
            role: htmlEditorOptions.role,
            name: index,
            value: value,
            ctx: htmlEditorOptions.ctx,
            index: index,
            trackChName: htmlEditorOptions.trackChName,
            userId: htmlEditorOptions.userId,
            convertUrls: htmlEditorOptions.convertUrls,
            localStorage: htmlEditorOptions.localStorage,
            wordsum: htmlEditorOptions.wordsum
        });
    });
}

function editorUplaodPanel(ed){
    var template = $.ezdia.template.get('editor-file-upload');
    var html = template();
    var wrapperObj = $("#ez-editor-file-upload-wrapper");

    if (!wrapperObj.length) {
        var divs = $('<div>',{
            id: 'ez-editor-file-upload-wrapper'
        });
       $('body').append(divs);
    }
    wrapperObj = $("#ez-editor-file-upload-wrapper");

    wrapperObj.html(html);
    wrapperObj.dialog({
        modal: true,
        title: "Choose file type",
        width: 400,
        height: 250,
        buttons: {
            Upload: function() {
                var panel = $(this);
                var fileName = $('#ez-editor-upload-file').val();
                if(!fileName){
                    $('#ez-editor-file-upload-msg').show().html('Please choose a file type to upload a file.').addClass('bg-danger');
                    return false;
                }
                $('#ez-editor-file-upload-msg, #ez-editor-file-upload-form').hide();
                var top = $('body').scrollTop();
                var loading = $('#ez-editor-file-upload-loading').show();

                $("#ez-editor-file-upload-form").ajaxForm({
                    url: "docToHtmlConverter.htm",
                    type: "POST",
                    dataType: 'text',
                    success: function(response){
                        var index = response.indexOf("<body>") + 6;
                        var len = response.indexOf("</body>");
                        response = response.substring(index, len);

                        ed.setContent(response);
                        ed.focus();
                        panel.dialog("close");
                        $('body').scrollTop(top);
                    }
                }).submit();
            },
            Cancel: function() {
                var top = $('body').scrollTop();
                $(this).dialog("close");
                $('body').scrollTop(top);
            }
        }
    });

    $('#ez-editor-upload-file').change(function(){
        var value = $('#ez-editor-upload-file').val();
        if(value){
            $('#ez-editor-file-upload-msg').hide();
            $('#ez-editor-upload-file-name').html(value);
        }
    });
}

function buildHTMLElement(htmlEditorArray, cols, metadata, key, value, isReadonly) {
    var content_template = $.ezdia.config.CONTENT_TEMPLATE_NAME;
    var content = '';
    var tempKeywords = '';
    var inputValue = value;
    var keywordDensityWrapper = '';
    htmlEditorArray[key] = metadata;
    copypasteConfig[key] = false;
    keywordDensityConfig[key] = false;
    ezdiaHtmlEmailTemplate[key] = {};
    readonlyEditorConfig[key] = isReadonly || false;
    //content += "<div style='position:relative'><div style='position: absolute; left: 500px;font-size: 1em; margin-top: 2px;'>";
    if (metadata) {
        if (metadata.copy) {
            $.each(metadata.copy, function(i, mval) {
                var fromfield = mval;
                for (var j = 0; j < cols.length; j++) {
                    if (cols[j].name === fromfield) {
                        copypasteConfig[key] = copypasteConfig[key] || [];
                        copypasteConfig[key].push({
                            fromfield: fromfield,
                            tofield: key,
                            label: 'Paste ' + (cols[j].label || fromfield)
                        });
                        break;
                    }
                }
            });
        }
        if (metadata.keyword) {
              keywordDensityConfig[key] = metadata.keyword;
        }
        if (metadata.content_template_name || metadata.content_template_type) {
            //for post request change
            //ezdiaHtmlEmailTemplate[key] = $.ezdia.templateDb.get(metadata.content_template_name, metadata.content_template_type);
            ezdiaHtmlEmailTemplate[key] = {
                name: metadata.content_template_name,
                type: metadata.content_template_type
            };
        }
        if (metadata.plainText) {
            inputValue = convertPlainTextToHtml(inputValue);
        }
    }

    if($.isEmptyObject(ezdiaHtmlEmailTemplate[key])){
        ezdiaHtmlEmailTemplate[key] = false;
    }
    content += "<textarea id='" + key + "' name='" + key + "' class='standard-textarea form-control html " + key + "'>" + inputValue + "</textarea>" + keywordDensityWrapper;
    return content;
}

function buildShowHistoryLink(key, label, metadata, edittype, hideBtn) {
    if (metadata) {
        if (metadata.showhistory) {
            var data = {
                key: key,
                type: 'showhistory',
                edittype: edittype,
                showHistoryLabel: label,
                showhistoryLinkId: key + 'showhistory',
                hideBtn: hideBtn
            };
            createActionLinkObj(data);
        }
    }
}


function buildStatuses(status, key, value) {
    var content = '';
    content += "<div id='" + key + "'></div>";
    status[key] = value;
    return content;
}


function createDateField(array) {
    $.each(array, function(key, column) {
        var id = "#" + (column.id || key);
        var config = column.config || {};
        var elem = $('#' + column.hiddenId);

        var obj = {
            controlType: 'select',
            oneLine: true,
            timeFormat: 'hh:mm TT',
            dateFormat: 'MM d, yy',
            altFormat: 'yy-mm-dd',
            altTimeFormat: 'HH:mm',
            altFieldTimeOnly: false,
            altField: "#" + column.hiddenId
        };

        if(!config.backDate) {
            obj.minDate = 0;
        }

        $(id).datetimepicker(obj).on('change', function() {
            elem.trigger('change');
        });
    });
}


function buildUrlField(key, value) {
    var input = '';
    var content = '';
    var linkHref = '';
    var reg = /<\s*a*\s[A-Za-z0-9\s\=\"\'\%\&\:\/\.\_\-\/\?]*>\s*[^ ]*\s*<\/a>/;
    value = $.trim(value);
    if (reg.test(value)) {
        linkHref = $(value).attr('href');
        if (linkHref.indexOf("http://") === -1 && linkHref.indexOf("https://") === -1) {
            value = $(value).attr('href', "http://" + linkHref);
            value = $('<div>', {html: value}).html();
        }
        if (!$(value).attr('target')) {
            value = $(value).attr('target', '_blank');
            content = $('<div>', {html: value}).html();
        } else {
            content = value;
        }
    } else {
        linkHref = (value.indexOf("http://") === -1 && value.indexOf("https://") === -1) ? "http://" + value : value;
        var url = decodeURIComponent(linkHref);
        if (url == linkHref) {
            url = encodeURI($.trim(linkHref));
        } else {
            url = linkHref;
        }
        content = '<a id="' + key + '_url" href="' + url + '" target="_blank">' + value + '</a>';
    }
    
    if (key) {
        input = '<input type="text" id="' + key + '_dummy" name="' + key + '_dummy" style="display: none">';
    }

    return content + input;
}



function buildGroupField(key, value, metadata, placeholder, grouptypeArray) {
    var content = '';

    if (!placeholder) {
        placeholder = '';
    }

    content += "<input type='text' class='form-control' id='" + key + "' name='" + key + "' value='" + value + "' placeholder='" + placeholder + "'/>";
    grouptypeArray.push({id: key, key: metadata});
    return content;
}

function createGroupAutoCompleteElement(grouptypeArray) {
    $.each(grouptypeArray, function(index, value) {
        var tags = [];
        var arr =[];
        var elem = null;

        if (value && value.key) {
            if(typeof value.key === 'string') {
                arr = value.key.split("##");
            } else if(value.key.options){
                 arr = value.key.options;
            } else {
                arr = value.key;
            }
            $.each(arr, function(idx, mval) {
                if (mval && mval.toLowerCase() !== 'other') {
                    tags.push(mval);
                }
            });
        }

        elem = $("#" + value.id);
        elem.typeahead({
            hint: true,
            highlight: true,
            minLength: 0
        }, {
            name: value.id,
            displayKey: '',
            source: typeaHeadstringMatcher(tags)
        }).on("click", function() {
            var ev = $.Event("keydown");
            ev.keyCode = ev.which = 40;
            $(this).trigger(ev);
            return true;
        }).on('typeahead:selected', function() {
            elem.trigger('change');
        });
    });
}

var typeaHeadstringMatcher = function(strs) {
    return function findMatches(q, cb) {
        var matches = [];
        var substrRegex = new RegExp(q, 'i');

        $.each(strs, function(i, str) {
            if (substrRegex.test(str)) {
                matches.push({value: str});
            }
        });

        cb(matches);
    };
};


function escapeHtml(unsafe) {
    var content = '';
    if (unsafe) {
        content =  unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;")
            .replace(/’/g, "&rsquo;");
    }
    return content;
}

function convertHtml(unsafe) {
    var content = '';
    if (unsafe) {
        content = unsafe
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, "\"")
            .replace(/&rsquo;/g, "’")
            .replace(/&#039;/g, "'")
            .replace(/&#39;/g, "'")
            .replace(/\n/g, "\\n");
    }
    return content;
}

$.fn.switchClass = function(options) {
    var self = $(this);
    self.addClass(options.add);
    if ($.isArray(options.remove)) {
        $.each(options.remove, function(index, value) {
            self.removeClass(value);
        });
    } else {
        self.removeClass(options.remove);
    }

    return self;
};

function getCustomConfig(field) {
    var pageParams = $.ezdia.config.pageParams || {};
    var accountName = customAcctName || pageParams.account || $('#accountName').val();
        role = role || pageParams.role;
    var accountConfig = customer_config && customer_config[accountName] && customer_config[accountName][field];
    var roleConfig = customer_config && customer_config[accountName] && customer_config[accountName][role]
            && customer_config[accountName][role][field];
    var elementConfig = customer_config && customer_config[accountName] && customer_config[accountName][role]
            && customer_config[accountName][role][field];
    if (!elementConfig) {
        elementConfig = customer_config && customer_config[accountName] && customer_config[accountName][field] &&
                customer_config[accountName][field];
    }
    return (accountConfig, roleConfig, elementConfig);
}

$.jgrid.extend({
    columnExport: function() {
        var id = '#columnExport_'+$(this).attr('id');
        callExportData(id);
    }
});


// TODO: REMOVE THIS
function createUserSettingData(action, queryName, columnName) {
    var pageParams = $.ezdia.config.pageParams;
    var tab = pageParams.tab;
    var data;
    var accountName = 'all';
    if($('#accountName').val()) {
	accountName = $('#accountName').val();
    }
    var role = 'all';
    if($('#role').val()) {
	role = $('#role').val();
    }
    data = "&accountName=" + accountName;
    data += "&role=" + role;
    data += "&email=" + pageParams.email;
    data += "&action=" + action;
    if (columnName) {
        data += "&columnValue=" + columnName;
    }
    if (tab || queryName) {
        data += "&tab=";
        if (tab === 'Dashboard') {
            data += queryName.substring(5);
        } else {
            data += tab;
        }
    }
    return data;
}

// TODO: REMOVE THIS
function clearUserSettings(data, type) {

    $.ajax({
        type: "POST",
        url: "clearUserSettings.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
	    if(type == 'export') {
		refreshColModel(type);
            }
        }
    });
}

// TODO: REMOVE THIS
function saveUserSettings(data, type) {
    $.ajax({
        type: "POST",
        url: "saveUserSettings.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
	    if(type == 'export') {
		refreshColModel(type);
            } else if (type == 'GlobalDashboard' || type == 'Dashboard') {
                $.ezdia.dashboard.pinSuccess(type);
            }
        },
        error: function (response) {
            html = "Settings not saved successfully!!";
            $("#statusMsg").html(html);
            $("#statusMsg").dialog({
                modal: true,
                title: 'Save User Settings',
                buttons: {
                    Ok: function () {
                        $(this).dialog("close");
                    }
                }
            });
        }
    });
}

function timer() {
    var interval;
    this.isActive = false;
    var time = 0;
    this.play = function(playTime) {
        this.isActive = true;
        time = playTime || time;
        interval = setInterval(function() {
            activityTimer('setTime', formatCountdownTime(time));
            time -= 100;
            return this;
        }, 1000);
    };
    this.pause = function() {
        this.isActive = false;
        clearInterval(interval);
        return this;
    };
    this.reset = function() {
        time = 0;
        activityTimer('setTime', formatCountdownTime(time));
        this.pause();
    };
    this.toggle = function() {
        if (this.isActive) {
            this.pause();
        } else {
            this.play();
        }
    };
}

function formatTime(time) {
    var min = parseInt(time / 6000);
    var sec = parseInt(time / 100) - (min * 60);
    return ((min > 0 ? ("0" + min).slice(-2) : "00") + ":" + ("0" + sec).slice(-2));
}

function formatCountdownTime(time) {
    var overDue = time;
    time = Math.abs(time);
    var day = parseInt(time / 8640000);
    var hour = parseInt(time / 360000) - (day * 24);
    var min = parseInt(time / 6000) - ((hour + (day * 24)) * 60);
    var sec = parseInt(time / 100) - (min * 60);

    hour = (hour > 0 ? ("0" + hour).slice(-2) : "00") + ":";
    min = (min > 0 ? ("0" + min).slice(-2) : "00") + ":";
    sec = ("0" + sec).slice(-2);

    if (overDue < 0) {
        day = day || '1';
        $('#overDueTime').html(day);
        $('#activityTimer').switchClass({add: 'panel-danger activity-timer-over-due', remove: 'panel-default'});
    }
	else {
            day = (day) ? day +' day(s) and' : '';
            $('#dayDueTime').html(day);
	}
    return (hour + min + sec);
}

function converToSeconds(time) {
    if (!time) {
        return 0;
    }
    if (time.indexOf(':') !== -1) {
        var timeArray = time.split(':');
        var min = timeArray[0] * 6000;
        var sec = timeArray[1] * 100;

        return parseInt((min + sec) / 100);
    } else {
        return parseInt(time);
    }
}

function startActivityTimer(id, dueDate) {

    var todayTime = new Date();
    var dt;
    if (dueDate) {
        var dt = $("#grid").jqGrid('getCell', id, dueDate);
        dt = $(dt).attr('data-date');
    }

    if (dt) {
        var assTime = new Date(dt);
        var time = (todayTime - assTime) / 10;
        if (time < 8640000) {
            time = 8640000 - time;
        } else {
            time *= -1;
        }

        activityTimer('start', time);
    }
}

function activityTimer(type, time, control) {
    if (type === 'start') {
        this.newTimer = new timer();
        var template = $.trim($('#activityTimerTemplate').html());
        template = template.replace(/{{activityTimer}}/ig, 'activityTimer');
        $('.animated-wrapper').append(template);
        var panel = $('#activityTimer');
        if (control) {
            $('#timerPlayPause').on('click', function() {
                var self = $(this);
                self.toggleClass('timer-pause');
                if (self.hasClass('timer-pause')) {
                    self.attr('data-original-title', 'Play');
                } else {
                    self.attr('data-original-title', 'Pause');
                }
            });
        }
        panel.fadeIn("slow");
        $('#timerHideShow').click(function() {
            var $this = $(this);
            var displayType = $this.attr('data-display');
            if (displayType === 'show') {
                $this.attr('data-display', 'hide');
                panel.addClass('fade-out-body');
            } else {
                $this.attr('data-display', 'show');
                panel.removeClass('fade-out-body');
            }
        });
        // timerPanelPos(panel);
        panel.addClass('timer-scroll-pos').css('z-index', 11111111111)
        newTimer.play(time);

    } else if (this.newTimer) {
        switch (type) {
            case 'play':
                newTimer.play();
                break;
            case 'pause':
                newTimer.pause();
                break;
            case 'reset':
                newTimer.reset();
                break;
            case 'toggle':
                newTimer.toggle();
                break;
            case 'destroy':
                newTimer.reset();
                $('#activityTimer').remove();
                break;
            case 'setTime':
                $('#timer').html(time);
                break;
            default :
                break;
        }
    }
}

function removeTimer() {
    activityTimer('destroy');
    recordActivityTime('destroy');
}

function recordActivityTime(type) {
    var self = this;
    currentAccountKey = ezdia.config.JS.currentAccountKey;
    activityTime = ezdia.config.JS.activityTime;
    self.type = type;
    self.t = self.totalTime;
    self.setTimer = function() {
        clearTimeout(self.pauseInterval);
        self.pauseInterval = setTimeout(self.clearTimer, 10000);
        if (!self.isActive) {
            self.isActive = true;
            self.clockInterval = setInterval(function() {
                if (self.hasLocal || (localStorage[currentAccountKey] && localStorage[currentAccountKey] !== 0)) {
                    if (!self.localTimeStorage) {
                        localStorage[self.startTimeKey] = activityTime[self.startTimeKey];

                        delete activityTime[self.totalTimeKey];
                        delete activityTime[self.startTimeKey];

                        self.localTimeStorage = true;
                    }
                    localStorage[self.totalTimeKey] = self.time;
                } else {
                    activityTime[self.totalTimeKey] = self.time;
                }
                self.time += 1;
                return self;
            }, 1000);
        }
    };

    self.clearTimer = function() {
        clearTimeout(self.clockInterval);
        self.isActive = false;
        self.doc = true;
    };

    if (self.type === 'start') {
        self.clockInterval;
        self.pauseInterval;
        self.isActive = false;
        self.doc = true;
        self.localTimeStorage = false;
        self.hasLocal = (localStorage[currentAccountKey] && localStorage[currentAccountKey] !== 0);
        self.totalTimeKey = currentAccountKey + '.desk.total.time';
        self.startTimeKey = currentAccountKey + '.desk.start.time';
        self.time = (self.hasLocal) ? converToSeconds(localStorage[self.totalTimeKey]) : 0;
        activityTime[self.startTimeKey] = (self.hasLocal) ? localStorage[self.startTimeKey] : getCurrentDateTime();
        clearTimeout(self.clockInterval);
        clearTimeout(self.pauseInterval);
        self.setTimer();

        $(document).bind('mousemove  keypress', function() {
            if (self.doc) {
                self.setTimer();
            } else {
                self.setTimer();
                self.doc = true;
            }
        });
    }
    if (self.type === 'ed') {
        self.doc = false;
        self.setTimer();
    }
    if (self.type === 'destroy') {
        clearTimeout(self.clockInterval);
        clearTimeout(self.pauseInterval);
    }
}

function removeHighlightKeyword(id) {
    if (edKeywordHighlights[id]) {
        var ed = tinymce.get(id);
        ed.dom.remove(ed.dom.select('.highlight-keyword'), true);
    }
}


function buildFieldDropDown(counter, fieldName) {
    var content = '';
    var status = '<s:property value="userRole.submitField"/>';
    var serchfieldsObj = eval('(' + searchFieldsJson + ')');
    /* if (counter > 0) {
     content = "</br>";
     }*/
    content += "<div class='form-group' data-row='form-group'><select class='form-control' id='field" + counter + "' onchange='buildOperatorDropDown(" + counter + "," + null + "," + null + "," + true + "," + null + "," + null + "," + null + ");'>";
    content += "<option value=''>Select Field</option>";
    $.each(serchfieldsObj, function(name, field) {
        var value = field.name ? field.name : name;
        content += '<option value="' + value + '" ' + ((value === fieldName) ? 'selected' : '') + ' >' + ((status === value) ? 'My Status' : field.label) + '</option>';
    });
    content += "</select></div>";
    return content;
}

function populateSearchFromRequestParams(reqParams) {
    var populateBSrch = false;
    var bsrchFields = basicSearchFields.split(", ");
    var counter = (basicSearchFields.length === 0) ? 0 : bsrchFields.length;
    var bsrchCount = counter;
    var params = {};

    if (reqParams) {
        params = $.parseJSON(reqParams);
        var serchfieldsObj = {};
        if (searchFieldsJson) {
            serchfieldsObj = eval('(' + searchFieldsJson + ')');
        }
        $.each(params, function(key, value) {
            var name = key;
            var val = value ? value[0] : '';
            if (name !== null && name !== '' && val !== null && val !== '') {
                val = decodeURIComponent(val);
                if (name === 'state') {
                    var statusField = submitFields;
                    name = statusField;
                }
                var index = bsrchFields.indexOf(name);
                if (index !== -1) {
                    $("#fieldVal" + index).val(val);
                    populateBSrch = true;
                }
                else if (serchfieldsObj[name]) {
                    var type = serchfieldsObj[name].type;
                    var searchFieldDiv = $(document.createElement('div')).attr({"id": 'searchDiv' + counter, "class": "clearfix"});
                    var fields = buildFieldDropDown(counter, name);
                    searchFieldDiv.append(fields);
                    var operators = buildOperatorDropDown(counter, 'EQ', name, false, val, null, null);
                    searchFieldDiv.append(operators);
                    searchFieldDiv.appendTo("#SearchFieldGroup");
                    if (type === "date") {
                        $("#fieldVal" + counter).datepicker({
                            dateFormat: 'yy-mm-dd'
                        });
                    }
                    counter++;
                }
            }
        });
    }
    var addBtn = "<a id='addBtn' onclick='addButtonClick();' type='button' class='btn btn-default'><span id='plusminusbtn' class='glyphicon glyphicon-plus'></span></a>";
    $("#searchDiv" + (counter - 1)).append(addBtn);
    searchCounter = counter;
    if (populateBSrch || counter > bsrchCount) {
        return true;
    }
    return false;
}

function getFieldType(fieldName) {
    var tempserchfieldsObj = eval('(' + searchFieldsJson + ')');
    for (var idx = 0; idx < tempserchfieldsObj.length; idx++) {
        var name = tempserchfieldsObj[idx].name;
        if (name === fieldName) {
            return tempserchfieldsObj[idx].fieldType;
        }
    }
}

function getFieldAddon(fieldName) {
    var tempserchfieldsObj = eval('(' + searchFieldsJson + ')');
    for (var idx = 0; idx < tempserchfieldsObj.length; idx++) {
        var name = tempserchfieldsObj[idx].name;
        if (name === fieldName) {
            return tempserchfieldsObj[idx].addon;
        }
    }
}

function getFieldConfig(fieldName) {
    var tempserchfieldsObj = eval('(' + searchFieldsJson + ')');
    for (var idx = 0; idx < tempserchfieldsObj.length; idx++) {
        var name = tempserchfieldsObj[idx].name;
        if (name === fieldName) {
            return tempserchfieldsObj[idx].config;
        }
    }
}

// TODO: REMOVE THIS
$("#genericExportBtn").click(function() {
    genericExport();
});

// TODO: REMOVE THIS
var genericExport = function(query, customFields){
    var $preparingFileModal = $("#preparing-file-modal");
    var searchdata = query || getSearchQueryString();
    $.fileDownload("genericExport.htm", {
        preparingMessageHtml: "We are preparing your report, please wait...",
        failMessageHtml: "There was a problem generating your report, please try again.",
        httpMethod: "POST",
        datatype: "json",
        data: {
            accountName: $('#accountName').val(),
            formtype: $("#pageTemplateName").val(),
            searchString: function() {
                if (searchdata && searchdata !== "" && searchdata !== null && searchdata !== undefined && searchdata.length > 0) {
                    return searchdata;
                }
                else {
                    return "";
                }
            },
            customFields: function() {
                if (customFields && customFields.length > 0)
                    return 'id,' + customFields;
                else
                    return "";
            }
        }, successCallback: function(responseHtml,url) {
            if(typeof responseHtml  === "string"){
                var noHTML = /(<([^>]+)>)/ig;
                    responseHtml = responseHtml.replace(noHTML,"");
                    responseHtml = $.ezdia.getJsonObject(responseHtml);
                    if(responseHtml.success){
                        alert("Success",responseHtml.success);
                    }
            }
        },
        failCallback: function(responseHtml, url) {
            if(typeof responseHtml  === "string"){
                var noHTML = /(<([^>]+)>)/ig;
                responseHtml = responseHtml.replace(noHTML,"");
                responseHtml = $.ezdia.getJsonObject(responseHtml);
                if(responseHtml.success){
                    failMessageHtml = responseHtml.success;
                    alert("Success",failMessageHtml);
                }
                else{
                    failMessageHtml= "There was a problem generating your report, please try again."
                    alert("Error",failMessageHtml);
                    $preparingFileModal.dialog('close');
                }
            }
            else {
                failMessageHtml= "There was a problem generating your report, please try again."
                alert("Error",failMessageHtml);
                $preparingFileModal.dialog('close');
            }
            $("#error-modal").dialog({modal: true});
        }
    });
};


function fetchContentHistory(columnName, columnLabel, edittype, hideBtn) {
    var template = ezjHtmlTemplates.getTemplates('deskShowHistory');
    var content = {
        wrapperId: 'showHistoryWrapper_' + columnName
    };

    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (!selectAll && (!selIds || selIds.length === 0)) {
        alert("Error", "Please select at least one item");
        return;
    }
    var data = "&accountName=" + $('#accountName').val();
    data += "&role=" + $('#role').val();
    data += "&taskId=" + selIds;
    data += "&fieldName=" + columnName;
    var actionName = ezdia.config.currentQuickAction;
    if (actionName) {
        data += "&actionName=" + actionName;
    }

    var actionLinkWrapper = $('#actionLinkWrapper_' + columnName);
    var wrapperObj = $("#" + content.wrapperId);
    if (wrapperObj.length) {
        wrapperObj.remove();
    }
    $.ajax({
        type: "POST",
        url: "fetchContentHistoryList.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            var list = [];
            var parentEl = $('[name=' + columnName + ']').parents('.inputs');
            $.each(response, function(i, obj) {
                var tempObj = {};
                if (i === 0) {
                    list.push({
                        id: '',
                        linkId: '',
                        createdOn: obj.createdOn,
                        modifiedBy: obj.lastModifiedByRole,
                        taskId: obj.taskId,
                        columnName: columnName,
                        columnLabel: columnLabel,
                        edittype: edittype,
                        current: true
                    });
                }
                var res = response[i + 1];
                if (res) {
                    tempObj = {
                        id: obj.id,
                        linkId: obj.id + '_showhistoryLink',
                        createdOn: res.createdOn,
                        modifiedBy: res.lastModifiedByRole,
                        taskId: obj.taskId,
                        columnName: columnName,
                        columnLabel: columnLabel,
                        edittype: edittype
                    };
                } else {
                    tempObj = {
                        id: obj.id,
                        linkId: obj.id + '_showhistoryLink',
                        taskId: obj.taskId,
                        columnName: columnName,
                        columnLabel: columnLabel,
                        edittype: edittype
                    };

                }
                list.push(tempObj);
                parentEl.on('click', '#' + tempObj.linkId, function() {
                    fetchContent(tempObj, hideBtn);
                });
            });
            if (list.length) {
                content.cls = 'show-history-wrapper-padding ' + edittype;
                content.list = list;
            } else {
                content.cls = edittype;
                content.nodata = true;
            }
            actionLinkWrapper.before(template(content));
            parentEl.addClass('show-show-history');
            $('#' + content.wrapperId).collapse();
        },
        error: function() {
            content.error = true;
            actionLinkWrapper.before(template(content));
            $('#' + content.wrapperId).collapse();
        }
    }).always(function() {
//      activeBtn.button('reset');
    });
}

function fetchContent(options, hideBtn) {
    var historyComparewrapperId = $("#" + options.id + '_' + options.columnName);
    if (historyComparewrapperId.html()) {
        if (historyComparewrapperId.hasClass('in')) {
            hideHistoryCompare();
        } else {
            showHistoryCompare();
        }
        return false;
    }
    var template = ezjHtmlTemplates.getTemplates('deskShowHistoryCompare');

    var data = "&accountName=" + $('#accountName').val();
    data += "&role=" + $('#role').val();
    data += "&historyId=" + options.id;
    data += "&fieldName=" + options.columnName;
    data += "&taskId=" + options.taskId;
    var actionName = ezdia.config.currentQuickAction;
    if (actionName) {
        data += "&actionName=" + actionName;
    }

    $.ajax({
        type: "POST",
        url: "fetchHistoricalContent.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            if (typeof response === "object") {
                var content = {
                    createdOn: options.createdOn,
                    modifiedBy: options.modifiedBy,
                    content: response.contentOld,
                    hideBtn: hideBtn
                };
                historyComparewrapperId.html(template(content))
                        .find('#compareCurrentCopy').on('click', function() {
                    var diffContent = getContentDiff(options, response.contentOld);
                    historyComparewrapperId.find('#diffContent').html(diffContent);
                }).end().find('#revertCopy').on('click', function() {
                    setContentDiff(options, response.contentOld);
                    hideHistoryCompare();
                }).end().find('#close').on('click', function() {
                    hideHistoryCompare();
                });
                showHistoryCompare();
            }
        }
    });
    function showHistoryCompare() {
        historyComparewrapperId.prev('a')
                .addClass('history-compare-show')
                .end().collapse("show");

    }
    function hideHistoryCompare() {
        historyComparewrapperId.prev('a')
                .removeClass('history-compare-show')
                .end().collapse("hide");
    }
}

function fetchWorkFlowHistory(columnName, targetRole) {
    var template = ezjHtmlTemplates.getTemplates('deskWorkFlowHistory');
    var content = {
        wrapperId: 'workFlowHistoryWrapper_' + columnName
    };

    var selIds = getGridSelRow();
    var selectAll = $('#selectAll').is(':checked');
    if (!selectAll && (!selIds || selIds.length === 0)) {
        alert("Error", "Please select at least one item");
        return;
    }

    var data = "&accountName=" + $('#accountName').val();
    data += "&role=" + $('#role').val();
    data += "&taskId=" + selIds;
    if (targetRole) {
        data += "&targetRole=" + targetRole;
    }

    var actionLinkWrapper = $('#actionLinkWrapper_' + columnName);
    var wrapperObj = $("#" + content.wrapperId);
    if (wrapperObj.length) {
        wrapperObj.remove();
    }

    $.ajax({
        type: "POST",
        url: "fetchWorkFlowHistory.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            var list = [];
            var parentEl = $('[name=' + columnName + ']').parents('.inputs');

            $(response).each(function(i, obj) {
                var arr = (obj.createdOn).split(' ');
                var date = arr[0] + ' ' + arr[1];
                var prettyDt = moment(date).fromNow();
                list.push({
                    role: obj.actionRole,
                    status: obj.actionStatusNew,
                    date: prettyDt,
                    dataTooltip: date,
                    arrow: (i === 0) ? false : true,
                    active: (response.length - 1 === i) ? true : false
                });
            });
            if (list.length) {
                content.list = list;
            } else {
                content.nodata = true;
            }
            actionLinkWrapper.before(template(content));
            parentEl.addClass('show-workflow-history');
            $('#' + content.wrapperId).collapse();
        },
        error: function() {
            content.error = true;
            actionLinkWrapper.before(template(content));
        }
    });
}

function getWorkFlowHistory(selIds, new_status) {
    var returnData;
    var data = "&accountName=" + $('#accountName').val();
    data += "&role=" + $('#role').val();
    data += "&taskId=" + selIds;
    data += "&targetRole=" + $('#role').val();

    if (new_status) {
        data += "&status=" + new_status;
    }
    $.ajax({
        type: "POST",
        async: false,
        url: "fetchWorkFlowHistory.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            returnData = response;
        }
    });
    return returnData;
}

function setGridCellTitle(gridId) {}

function validateFields(btnLabel) {
    $('.ez-error-msg').remove();
    var data = getCustomConfig('validate');
    var errorFlag = false;
    if (data) {
        var rowId = getGridSelRow();
        $.each(data, function(index, obj) {
            $.each(obj, function(key, value) {
                var status = $($("#grid").jqGrid('getCell', rowId, key)).html();
                var match = false;

                if (value.NE) {
                    if (key === 'action_label') {
                        match = ($.inArray($.trim(btnLabel), value.NE) === -1);
                    } else {
                        match = ($.inArray(status, value.NE) === -1);
                    }
                } else if (value.EQ) {
                    if (key === 'action_label') {
                        match = ($.inArray(btnLabel, value.EQ) !== -1);
                    } else {
                        match = ($.inArray(status, value.EQ) !== -1);
                    }
                }

                if (match) {
                    $.each(obj.fields, function(index, id) {
                        var elem = $('[name=' + id + ']');
                        var returnType;
                        if (elem.length) {
                            switch (obj.condition) {
                                case 'required':
                                    returnType = isEmptyElement(id);
                                    break;
                                case 'url':
                                    returnType = isUrl(id);
                                    break;
                                default :
                                    break;
                            }                            
                        }
                        if (returnType) {
                            displayErrorMsg(id, obj.message);
                            errorFlag = true;
                        }
                    });
                }
            });
        });
        if (errorFlag) {
            var scrollTop = $('.ez-error-msg:first').parent().offset().top;
            $('html, body').animate({
                scrollTop: scrollTop
            }, 500);
        }
        return errorFlag;
    } else {
        return false;
    }
}

function isEmptyElement(id) {
    var elem = $('[name=' + id + ']');
    var type = elem.attr('type');
    var value = '';

    if (type == 'radio') {
        return !elem.is(':checked');
    } else {
        value = elem.val();
        if ($('#' + id + '_slider').length) {
            value = parseInt(value) === 0 ? '' : value;
        }
        return value ? false : true;
    }
}

function isUrl(id) {
    var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    var value = $('#' + id).val();
    return !pattern.test(value);
}

function displayErrorMsg(id, msg) {
    var content = $('<div>', {
        for : id,
        class: 'validation-error-msg ez-error-msg',
        html: msg
    });
    $('[name=' + id + ']').closest('[data-row="input"]').append(content);
}

function getGridSelRow(gridId) {
    return $.ezdia.getSelectedGridItemsIds(gridId);
}

function isGridMultiSelect() {
    var pageParams = $.ezdia.config.pageParams;
    return (pageParams.bulkUpdateFlag || pageParams.openProjectFlag || pageParams.isGridMultiselect) ? true : false;
}



function getColDataString(type, data, name) {
    var content = '';
    var $data = '';
    if (name == 'project_type'){
        return getDataFromString(data);
    }

    try {
        $data = $(data);

        switch (type) {
            case 'date':
                if ($data.length) {
                    content = $(data).data('date');
                    content = (content) ? content : '';
                } else {
                    content = data;
                }
                break;
            case 'url':
                if($data.length && $data[0].nodeName != 'A') {
                    var encode = $(data).data('encode');
                    content = $(data).data('url');
                    content = encode ? decodeURI(content) : content;
                } else {
                    content = data;
                }
                break;
            case 'inputlist':
                if($data.length) {
                    return ezj.inputListDataArray[$(data).attr('data-index')];
                } else {
                    return data;
                }
                break;
            case 'tag':
            case 'combo':
            case 'multichoice':
                if ($data.length) {
                    content = $(data).data('value')? $(data).data('value') : data;
                } else {
                    content = data;
                }
                break;
            case 'json':
            case 'inputtab':
            case 'role':
            case 'group':
            case 'radio':
            case 'checkbox':
                content = data;
                break;
            default :
                content = getDataFromString(data);
                break;
        }
    } catch (err) {
        content = data;
        // console.log(err);
    }

    return content;
}

function createAddContentWidget(data, id, dataId) {
    $('#addContentBlockWrapper').remove();
    var content = $('<div>', {
        id: 'addContentBlockWrapper',
        class: 'add-content-block-wrapper alert alert-info clearfix',
        html: data,
        'data-id': dataId
    });
    $('#' + id).after(content);

    var contentId = $('#addContentBlockWrapper');
    contentId.on('click', '#destroyAddContentWidget', function() {
        contentId.remove();
    });
}

function substringMatcher(url, type) {
    return function findMatches(q, cb) {
        var matches = [];
        // regex used to determine if a string contains the substring `q`
        var substrRegex = new RegExp(q, 'i');

        $.ajax({
            url: url,
            dataType: "json",
            data: {
                term: q
            },
            async: false,
            success: function(data) {
                $.each(data, function(i, str) {
                    if (substrRegex.test(str.value)) {
                        matches.push({value: str.value});
                    }
                });
                if (type === 'account') {
                    matches.push({
                        label: q,
                        value: "Add New Account"
                    });
                } else if (type === 'SOW') {
                    matches.push({
                        label: q,
                        value: "Add New SOW"
                    });
                } else if (type === 'order') {
                    matches.push({
                        label: q,
                        value: "Add New Order"
                    });
                } else if (type === 'company') {
                    matches.push({
                        label: q,
                        value: "Add New Company"
                    });
                }
            }
        });
        cb(matches);
    };
}

function createActionLinkObj(data) {
    var fieldId = data.key;
    if (!actionLinkArray[fieldId]) {
        actionLinkArray[fieldId] = {};
    }
    $.each(data, function(key, value) {
        if (key !== 'key') {
            if (key === 'type') {
                actionLinkArray[fieldId][value] = true;
            } else {
                actionLinkArray[fieldId][key] = value;
            }
        }
    });
}

function createFieldActionLink() {
    var template = ezjHtmlTemplates.getTemplates('fieldActionLink');

    $.each(actionLinkArray, function(key, obj) {
        obj['key'] = key;
        $('[name='+key+']').parents('.inputs').append(template(obj));

        if (obj.workFlowLinkId) {
            $('#' + obj.workFlowLinkId).on('click', function() {
                selectedActionLink($(this));
                var wrapper = $('#workFlowHistoryWrapper_' + key);
                if (wrapper.length && wrapper.is(':visible')) {
                    wrapper.collapse('hide');
                    wrapper.parents('.inputs').removeClass('show-workflow-history');
                } else {
                    $('#showHistoryWrapper_' + key).remove();
                    fetchWorkFlowHistory(key);
                }
            });
        }

        if (obj.showhistoryLinkId) {
            $('#' + obj.showhistoryLinkId).on('click', function() {
                selectedActionLink($(this));
                var wrapper = $('#showHistoryWrapper_' + key);
                if (wrapper.length && wrapper.is(':visible')) {
                    wrapper.collapse('hide');
                    wrapper.parents('.inputs').removeClass('show-show-history');
                } else {
                    $('#workFlowHistoryWrapper_' + key).remove();
                    fetchContentHistory(key, obj.showHistoryLabel, obj.edittype, obj.hideBtn);
                }
            });
        }

        if (obj.localStorageLinkId) {
            $('#' + obj.localStorageLinkId).on('click', function() {
                reviewLocalStoredData(key, obj.fnObj);
            });
        }
    });
}

function selectedActionLink(self) {
    if (self.hasClass('selected')) {
        self.removeClass('selected');
    } else {
        self.addClass('selected').siblings().removeClass('selected');
    }
}

function strip(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

function getContentDiff(options, contentOld) {
    var dmp = new diff_match_patch();
    var contentNew = '';
    var id;
    if (options.edittype === 'html') {
        id = tinymce.get(options.columnName);
        contentNew = id.getContent();
    } else if (options.edittype === 'status') {
        id = $('#' + options.columnName + '-status');
        contentNew = id.val();
    } else {
        id = $('#' + options.columnName);
        contentNew = id.val();
    }
    var regex = '<\s*/[A-Za-z\s]*?>';
    var re = new RegExp(regex, "ig");
    contentOld = contentOld.replace(re, '\n');
    contentNew = contentNew.replace(re, '\n');

    var content = dmp.diff_main(strip(contentOld), strip(contentNew));
    dmp.diff_cleanupEfficiency(content);
    content = dmp.diff_prettyHtml(content);
    content = content.replace(/&para;/g, '');

    return content;
}


function setContentDiff(options, contentOld) {
    var id = options.columnName;
    if (options.edittype === 'html') {
        var ed = tinymce.get(id);
        ed.setContent(contentOld);
    } else if (options.edittype === 'slider') {
        $('#' + id).bootstrapSlider('setValue', parseInt(contentOld));
        setSliderValue(id, contentOld);
    } else if (options.edittype === 'status') {
        $('#' + id + '-status').val(contentOld);
    } else {
        $('#' + id).val(contentOld);
    }
}

function getPaymentData(quickActionName,viewType,role ){
        $("#showPaymentQuickActionsData").html('');
        $("#showPaymentQuickActionsData").html('<table id="actionDataGrid"></table>');
        var data = 'viewType='+viewType+'&quickActionName='+quickActionName+'&role='+role;
        $.ajax({
        type: "POST",
        url: "paymentQuickAction.htm",
        data: data,
        dataType: 'json',
        success: function(response) {
            renderGrid({gridid: '#actionDataGrid',
            data: response.rowData,
            colModel: response.colModel,
            colNames: response.colNames,
            rowNum: rowNum,pager:'no',
            rowList: rowList, caption: response.viewName});
        },
        error:function(response){
            //alert(response)
        }
    });
}

arrCountry = ["United States", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas, The", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "British Virgin Is.", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Rep.", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Dem. Rep.", "Congo, Repub. of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia, The", "Gaza Strip", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Fed. St.", "Moldova", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "N. Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Helena", "Saint Kitts & Nevis", "Saint Lucia", "St Pierre & Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome & Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Is", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands", "Wallis and Futuna", "West Bank", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];


function gridInputListDataFormatter(json, count) {
    var content = '';

    if (json) {
        var obj = $.ezdia.getJsonObject(json) || {};

        ezj.inputListDataArray[count] = json;

        if (!$.isEmptyObject(obj)) {
            $.each(obj, function(i, mval){
                if (typeof mval === 'object') {
                    mval = mval.value;
                }
                content += mval + '</br>';
            });
        }
    } else {
        ezj.inputListDataArray[count] = '';
    }

    return content;
}
